<template>
  <div class="check">
    <div class="box">
      <div class="row row--header">
        <h2>Základní kontrola jednotky</h2>
        <h2>{{ idUnit }}</h2>
      </div>
      <div class="row row--header">
        <h2>Aktualizováno</h2>
        <h2>{{ timestamp }}</h2>
      </div>
    </div>
    <div class="box">
      <div class="row">
        <button
          class="help"
          v-tooltip="{
            content:
              'Proveďte následující kroky:<br>- Zkontrolujte, zda jednotka není v místě bez mobilního signálu<br>- Zapněte a vypněte motor<br>- Klikněte na <i>Znovu načíst</i>'
            //show: result && !result.isConnected
          }"
        >
          ?
        </button>
        <h3>
          Spojení se serverem
        </h3>
        <div class="row row--with-number">
          <ul v-if="result && result.isConnected">
            <li>{{ timestamp }}</li>
          </ul>
          <div
            class="icon"
            v-bind:class="{ success: result && result.isConnected }"
          >
            <CheckIcon v-if="result && result.isConnected" /><CrossIcon
              v-else
            />
          </div>
        </div>
      </div>
      <div class="row">
        <button
          class="help"
          v-tooltip="
            'Proveďte následující kroky:<br>- Zapněte motor<br>- Přepněte přepínač pro typ jízdy do polohy 1 (soukromá)<br>- Přiložte čip pro identifikaci řidiče<br>- Jeďtě minimálně 2 kilometry<br>- Vypněte motor<br>- Klikněte na <i>Znovu načíst</i>'
          "
        >
          ?
        </button>
        <h3>
          Platná GPS pozice
        </h3>
        <div
          class="icon"
          v-bind:class="{ success: result && result.hasValidGpsPosition }"
        >
          <CheckIcon v-if="result && result.hasValidGpsPosition" /><CrossIcon
            v-else
          />
        </div>
      </div>
      <div class="row">
        <h3>Zapalování zapnuto</h3>
        <div
          class="icon"
          v-bind:class="{ success: result && result.hasIgnitionOn }"
        >
          <CheckIcon v-if="result && result.hasIgnitionOn" /><CrossIcon
            v-else
          />
        </div>
      </div>
      <div class="row">
        <h3>Zapalování vypnuto</h3>
        <div
          class="icon"
          v-bind:class="{ success: result && result.hasIgnitionOff }"
        >
          <CheckIcon v-if="result && result.hasIgnitionOff" /><CrossIcon
            v-else
          />
        </div>
      </div>
      <div class="row">
        <h3>Proběhla jízda</h3>
        <template v-if="result && result.isInOrion">
          <div
            class="icon"
            v-bind:class="{ success: result && result.hasTrip }"
          >
            <CheckIcon v-if="result && result.hasTrip" /><CrossIcon v-else />
          </div>
        </template>
        <template v-else>
          <div class="icon grey">
            <CircleIcon />
          </div>
        </template>
      </div>
      <div class="row">
        <h3>Přepínač služební/soukromá</h3>
        <div
          class="icon"
          v-bind:class="{ success: result && result.hasTripTypeSwitch }"
        >
          <CheckIcon v-if="result && result.hasTripTypeSwitch" /><CrossIcon
            v-else
          />
        </div>
      </div>

      <div class="row">
        <h3>Identifikace řidiče</h3>
        <div
          class="icon"
          v-bind:class="{ success: result && result.hasDriverIdentification }"
        >
          <CheckIcon
            v-if="result && result.hasDriverIdentification"
          /><CrossIcon v-else />
        </div>
      </div>
    </div>
    <div class="box">
      <div class="row row--header">
        <label
          for="controlCan"
          class="checkboxLabel"
          v-on:click="clickSwitcher"
        >
          <h3>Kontrola CAN</h3>
          <span v-bind:class="{ on: controlCan, 'switch-btn': true }"></span>
        </label>
        <input
          type="checkbox"
          id="controlCan"
          name="controlCan"
          v-model="controlCan"
        />
      </div>
      <div v-bind:class="{ visible: controlCan, additional: true }">
        <div class="row">
          <h3>Tachometr</h3>
          <div class="row row--with-number">
            <ul v-if="result && result.odometerValue !== false">
              <li>{{ getFormattedOdometer }} km</li>
              <li>{{ result.odometerTimestamp }}</li>
            </ul>
            <div
              class="icon"
              v-bind:class="{
                success:
                  result &&
                  result.odometerValue !== false &&
                  result.odometerTimestampValid
              }"
            >
              <CheckIcon
                v-if="
                  result &&
                    result.odometerValue !== false &&
                    result.odometerTimestampValid
                "
              /><CrossIcon v-else />
            </div>
          </div>
        </div>
        <div class="row" v-if="result && !result.batteryValue">
          <h3>Stav palivové nádrže</h3>
          <div class="row row--with-number">
            <ul v-if="result && result.fuelStateValue !== false">
              <li>{{ result.fuelStateValue }} l</li>
              <li>{{ result.fuelStateTimestamp }}</li>
            </ul>
            <div
              class="icon"
              v-bind:class="{
                success:
                  result &&
                  result.fuelStateValue !== false &&
                  result.fuelStateTimestampValid
              }"
            >
              <CheckIcon
                v-if="
                  result &&
                    result.fuelStateValue !== false &&
                    result.fuelStateTimestampValid
                "
              /><CrossIcon v-else />
            </div>
          </div>
        </div>
        <div
          class="row"
          v-if="result && !result.fuelStateValue && result.batteryValue !== false"
        >
          <h3>Úroveň nabití baterie</h3>
          <div class="row row--with-number">
            <ul v-if="result && result.batteryValue !== false">
              <li>{{ result.batteryValue }} %</li>
              <li>{{ result.batteryTimestamp }}</li>
            </ul>
            <div
              class="icon"
              v-bind:class="{
                success:
                  result && result.batteryValue!== false && result.batteryTimestampValid
              }"
            >
              <CheckIcon
                v-if="result && result.batteryValue !== false && batteryTimestampValid"
              /><CrossIcon v-else />
            </div>
          </div>
        </div>
      </div>
    </div>
<!--    <div class="box">-->
<!--      <div class="row row&#45;&#45;header">-->
<!--        <label-->
<!--          for="controlTacho"-->
<!--          class="checkboxLabel"-->
<!--          v-on:click="clickSwitcher"-->
<!--        >-->
<!--          <h3>Kontrola Tacho</h3>-->
<!--          <span v-bind:class="{ on: controlTacho, 'switch-btn': true }"></span>-->
<!--        </label>-->
<!--        <input-->
<!--          type="checkbox"-->
<!--          id="controlTacho"-->
<!--          name="controlTacho"-->
<!--          v-model="controlTacho"-->
<!--        />-->
<!--      </div>-->
<!--      <div v-bind:class="{ visible: controlTacho, additional: true }">-->
<!--        <div class="row">-->
<!--          <h3>Karta řidiče</h3>-->
<!--          <div class="row row&#45;&#45;with-number">-->
<!--            <ul v-if="result && result.driverCardValue">-->
<!--              &lt;!&ndash;              <li>{{ result.driverCardValue }}</li>&ndash;&gt;-->
<!--              &lt;!&ndash;              <li>{{ result.driverCardTimestamp }}</li>&ndash;&gt;-->
<!--            </ul>-->
<!--            <div-->
<!--              class="icon"-->
<!--              v-bind:class="{-->
<!--                success:-->
<!--                  result &&-->
<!--                  result.driverCardValue &&-->
<!--                  result.driverCardTimestampValid-->
<!--              }"-->
<!--            >-->
<!--              <CheckIcon-->
<!--                v-if="-->
<!--                  result &&-->
<!--                    result.driverCardValue &&-->
<!--                    result.driverCardTimestampValid-->
<!--                "-->
<!--              /><CrossIcon v-else />-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->

    <div class="btns-bottom">
      <div class="container">
        <div class="box btns" v-if="firstBtns && !edit">
          <button type="button" class="secondary" v-on:click="check">
            Aktualizovat
          </button>
          <button
            type="button"
            v-on:click="save"
            v-bind:disabled="!canContinue || pressContinueDisabled"
          >
            Pokračovat
          </button>
        </div>
        <div class="box btns" v-if="!firstBtns && !edit">
          <button type="button" class="secondary" v-on:click="save">
            Pokračovat bez kontroly
          </button>
          <button type="button" v-on:click="check">
            Zkontrolovat znovu
          </button>
        </div>
        <div class="box btns" v-if="edit">
          <button type="button" class="secondary" v-on:click="check">
            Zkontrolovat znovu
          </button>
          <button type="button" v-on:click="saveBack">
            Uložit a vrátit do historie
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import moment from "moment";
import store from "../store";

import CrossIcon from "@/icons/CrossIcon.vue";
import CheckIcon from "@/icons/CheckIcon.vue";
import CircleIcon from "@/icons/CircleIcon.vue";

export default {
  name: "Check",
  props: ["unit"],
  mounted() {
    document.title = "GPS Dozor Servis";

    if (this.unit) {
      this.edit = true;
      this.check();
    } else {
      this.firstLoad = true;
      this.checkStart();
    }
    this.idle();
  },
  components: {
    CrossIcon,
    CheckIcon,
    CircleIcon
  },
  computed: {
    idUnit() {
      if (this.unit) {
        return this.unit.imei;
      }
      return store.state.idUnit;
    },
    result() {
      if (store.state.checkResult != null) {
        if (this.firstLoad) {
          if (
            store.state.checkResult.fuelStateValue ||
            store.state.checkResult.odometerValue ||
            store.state.checkResult.batteryValue
          ) {
            this.controlCan = true;
          } else {
            this.controlCan = false;
          }

          if (store.state.checkResult.driverCardValue) {
            this.controlTacho = true;
          } else {
            this.controlTacho = false;
          }

          if (this.unit) {
            if (this.unit.checkCan == 1 || this.unit.checkCan == 2) {
              this.controlCan = true;
            } else {
              this.controlCan = false;
            }

            if (this.unit.checkTacho == 1 || this.unit.checkTacho == 2) {
              this.controlTacho = true;
            } else {
              this.controlTacho = false;
            }
          }

          this.firstLoad = false;
        }
      }
      return store.state.checkResult;
    },
    timestamp() {
      return moment(store.state.checkResult && store.state.checkResult.timestamp).format(
        "DD.MM.YYYY HH:mm"
      );
    },
    canContinue() {
      if (store.state.checkResult == null) {
        return false;
      }

      // if (store.state.checkResult.isConnected) {
      //   return true;
      // }

      return true;
    },
    getFormattedOdometer(){
      if(store.state.checkResult && store.state.checkResult.odometerValue){
        let result = (store.state.checkResult.odometerValue/1000).toFixed(0);
        let x = result.toString();
        var pattern = /(-?\d+)(\d{3})/;
        while (pattern.test(x))
          x = x.replace(pattern, "$1 $2");
        return x;
      }
    }
  },
  data: function() {
    return {
      edit: false,
      pressContinueDisabled: false,
      controlCan: null,
      controlTacho: null,
      firstLoad: true,
      firstBtns: true
    };
  },
  methods: {
    idle: function() {
      window.onload = this.resetTimer;
      window.onmousemove = this.resetTimer;
      window.onmousedown = this.resetTimer; // catches touchscreen presses as well
      window.ontouchstart = this.resetTimer; // catches touchscreen swipes as well
      window.onclick = this.resetTimer; // catches touchpad clicks as well
      window.onkeypress = this.resetTimer;
      window.addEventListener("scroll", this.resetTimer, true); // improved; see comments
    },
    resetTimer: function() {
      if (store.state.checkResult === null) {
        return;
      }
      if (
        moment(store.state.checkResult.timestamp) < moment().subtract(1, "hour")
      ) {
        if (!this.pressContinueDisabled) {
          alert("Pro další pokračování znovu načtěte jednotku.");
          this.pressContinueDisabled = true;
        }
      }
    },
    check: async function() {
      store.commit("showLoading");
      const result = await store.dispatch("check", {
        idUnit: (this.edit) ? this.unit.imei : store.state.idUnit
      });

      this.firstBtns = true;

      store.commit("hideLoading");

      if (result === false && store.state.hash === null) {
        store.commit("resetState");
        store.commit("saveState");
        this.$router.push({
          name: "Login",
          params: { infoProps: "Z bezpečnostních důvodů došlo k odhlášení." }
        });
      }

      this.$forceUpdate();
      this.pressContinueDisabled = false;
      store.commit("saveState");
    },
    save: function() {
      store.state.checkResult.isValidBasic =
        store.state.checkResult.isConnected;
      store.state.checkResult.controlCan = this.controlCan;
      store.state.checkResult.isValidCan =
        ((store.state.checkResult.fuelStateValue &&
          store.state.checkResult.fuelStateTimestampValid) ||
          (store.state.checkResult.batteryValue &&
            store.state.checkResult.batteryTimestampValid)) &&
        store.state.checkResult.odometerValue &&
        store.state.checkResult.odometerTimestampValid;
      store.state.checkResult.controlTacho = this.controlTacho;
      store.state.checkResult.isValidTacho =
        store.state.checkResult.driverCardValue &&
        store.state.checkResult.driverCardTimestampValid;
      store.state.checkResult.edit = this.edit;
      store.state.checkResult.unit = this.unit;
      this.$router.push("save");
    },
    saveBack: async function() {
      store.commit("showLoading");
      let result;

      let checkCan = 0;
      if (store.state.checkResult && this.controlCan) {
        if (
          ((store.state.checkResult.fuelStateValue &&
            store.state.checkResult.fuelStateTimestampValid) ||
            (store.state.checkResult.batteryValue &&
              store.state.checkResult.batteryTimestampValid)) &&
          store.state.checkResult.odometerValue &&
          store.state.checkResult.odometerTimestampValid
        ) {
          checkCan = 1;
        } else {
          checkCan = 2;
        }
      }

      let checkTacho = 0;
      if (store.state.checkResult && this.controlTacho) {
        if (
          store.state.checkResult.driverCardValue &&
          store.state.checkResult.driverCardTimestampValid
        ) {
          checkTacho = 1;
        } else {
          checkTacho = 2;
        }
      }

      this.unit.checkCan = checkCan;
      this.unit.checkTacho = checkTacho;
      this.unit.checkBasic =
        store.state.checkResult && store.state.checkResult.isConnected;

      result = await store.dispatch("getUnit", {
        unit: this.unit
      });
      if (result.editable) {
        result = await store.dispatch("editUnit", {
          unit: this.unit
        });
      } else {
        alert("Bohužel již nejde tuto jednotku upravovat.");
      }

      store.commit("hideLoading");

      if (result === false && store.state.hash === null) {
        store.commit("resetState");
        store.commit("saveState");
        this.$router.push({
          name: "Login",
          params: { infoProps: "Z bezpečnostních důvodů došlo k odhlášení." }
        });
      }

      if (result) {
        store.commit("saveState");
        this.$router.push("history");
      }
    },
    checkStart: function() {
      if (store.state.idUnit === null) {
        this.$router.push("/");
        return;
      }
    },
    clickSwitcher: function() {
      this.firstBtns = false;
    }
  }
};
</script>

<style scoped lang="less">
@import "../assets/less/1-base/variables";

.box {
  padding-top: 14px;
  padding-bottom: 14px;
  border-bottom: 1px solid @blue;
  &:first-child {
    margin-top: 0;
  }

  button {
    margin-top: 10px;
    &:first-child {
      margin-top: 0;
    }
  }

  &.btns {
    display: flex;
    align-items: center;
    border-bottom: 0;

    button {
      margin-top: 0;
      margin-left: 10px;
      &:first-child {
        margin-left: 0;
      }
    }
  }

  .row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 0 0 20px;
    position: relative;

    &--header {
      padding: 0;
      margin-top: 10px;

      &:first-child {
        margin-top: 0;
      }
    }

    &--with-number {
      ul {
        margin: 0 10px 0 0;
        text-align: right;
        list-style: none;
        li {
          font-size: 12px;
        }
      }
    }
  }

  .help {
    position: absolute;
    top: 8px;
    left: 0;
    width: 18px;
    margin-left: 0;
    padding: 0;
    border-radius: 4px;
  }

  h2,
  h3 {
    text-align: left;
    margin: 0;
    font-size: 14px;

    span {
      position: relative;
      margin-left: 4px;
      width: 18px;
      display: inline-block;
      height: auto;
      vertical-align: top;
      svg {
        position: absolute;
        top: -4px;
        left: 0;
        width: 18px;
      }
    }

    button {
      padding: 4px;
      width: auto;
      font-size: 14px;
      border-radius: 4px;
      margin-left: 4px;
    }
  }

  h3 {
    font-size: 14px;
    font-weight: 400;
  }

  h1 {
    text-align: center;
    margin-bottom: 20px;
  }

  .icon {
    color: @red;
    svg {
      width: 30px;
    }
    &.success {
      color: @green;
    }
    &.grey {
      color: @black;
    }
  }
}

h1 {
  text-align: center;
  margin-bottom: 40px;
  font-size: 24px;
}

.additional {
  display: none;
  padding-top: 10px;

  &.visible {
    display: block;
  }
}

.checkboxLabel {
  cursor: pointer;
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.check {
  padding-bottom: 50px;
}

.btns-bottom {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;

  .container {
    max-width: 100%;
    width: 400px;
    padding: 0 20px;
    margin: 0 auto;
    background: @white-common;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }

  button {
    font-size: 14px;
  }
}
</style>
